module.exports = __webpack_public_path__ + "img/bs_silo_1.13863a83.png";